import React, { Component } from 'react'
import { Loading } from '@myxplor/ui'
import { FormDisplayErrors, FormSelect } from '@myxplor/forms'
import LocalAsyncStore from '../../../../../local-async-store'

const select_options = data =>
  data.map(({ value, label }) => ({ value: value.care_id, label: label }))

const parent_id = (data, care_id) => {
  return data.find(({ value }) => value.care_id === care_id).value.parent_id
}

const setDefaultParentValue = (nextProps, currentValue) => {
  const data = nextProps.parent_select.data
  if (!currentValue && data && data.length > 0) {
    const options = select_options(nextProps.parent_select.data)
    onChosenParentChange(nextProps.onChange, nextProps.parent_select.data)(
      'care_id',
      options[0].value
    )
  }
}

const onChosenParentChange = (onChange, data) => (key, value) => {
  onChange(key, value)
  onChange('parent_id', parent_id(data, Number(value)))
}

class ParentSelect extends Component {
  componentDidUpdate(prevProps) {
    if (prevProps.parent_select.data !== this.props.parent_select.data)
      setDefaultParentValue(this.props, prevProps.values.care_id)
  }

  render() {
    const { values, errors, onChange } = this.props
    const { loading, data } = this.props.parent_select

    if (loading) return <Loading>Loading Parents</Loading>
    if (data.length === 0) return <FormDisplayErrors errors="No matching Parents" />
    if (data.length === 1) return null

    return (
      <FormSelect
        name="care_id"
        label="Parent"
        onChange={onChosenParentChange(onChange, data)}
        value={values.care_id}
        placeholder="Please select ..."
        options={select_options(data)}
        errors={errors.care_id}
        required
      />
    )
  }
}

const RenderLocalAsyncStore = LocalAsyncStore(
  'parent_select',
  ParentSelect,
  props => `${props.baseEndpoint}/care_enrolments_summary`
)

export default RenderLocalAsyncStore



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/create-enrolment/parent-select.js